module.exports = __webpack_public_path__ + "img/plslogo.dc330371.png";